import { IncreaseLevel } from './increase-level';
import { UpdateNetworkRole } from './update-network-role';

export function UpdateUserData(): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <IncreaseLevel />
      <UpdateNetworkRole />
    </div>
  );
}
